<template>
  <div class="h-400px overflow-y-auto">
    <v-list-item v-show="listaSegmentos.length > 1" class="p-0 ma-0 ml-n4">
      <v-btn
        v-if="segmentosSelecionados.length === listaSegmentos.length"
        icon
        @click="desmarcarTodosSegmentos"
      >
        <v-icon color="primary">mdi-checkbox-marked</v-icon>
      </v-btn>

      <v-btn v-else icon @click="selecionarTodosSegmentos">
        <v-icon v-if="segmentosSelecionados.length > 0" color="primary">mdi-minus-box</v-icon>
        <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
      </v-btn>

      <v-list-item-title class="font-weight-bold">{{ txtBotaoSelecionarTodos }}</v-list-item-title>
    </v-list-item>

    <v-list-item v-for="item in listaSegmentos" :key="item.id" class="p-0 ma-0 ml-n4">
      <v-btn v-if="segmentosSelecionados.includes(item.id)" icon @click="descelecionarSegmento(item)">
        <v-icon color="primary">mdi-checkbox-marked</v-icon>
      </v-btn>

      <v-btn v-else icon @click="selecionarSegmento(item)">
        <v-icon>mdi-checkbox-blank-outline</v-icon>
      </v-btn>

      <v-list-item-title :title="`${item.descricao} (${item.qtd_produto})`">
        {{ item.descricao }} ({{item.qtd_produto}})
      </v-list-item-title>
    </v-list-item>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import SegmentoAPI from "@/api/segmento"

export default {
  name: "Segmentos",
  props: {
    id_comprador: {
      type: [Number, String]
    }
  },
  data: () => ({
    menu: false,
    listaSegmentos: [],
  }),
  computed: {
    ...mapGetters({
      fornecedorCompra: "fornecedor/getFornecedor",
      segmentosSelecionados: "segmentosCompra/getItens"
    }),
    txtBotaoSelecionarTodos () {
      return this.segmentosSelecionados.length === this.listaSegmentos.length
        ? "DESMARCAR TODOS"
        : "MARCAR TODOS"
    }
  },
  watch: {
    fornecedorCompra () {
      this.buscarListaDeSegmentos()
    }
  },
  mounted() {
    this.buscarListaDeSegmentos()
  },
  destroyed() {
    this.desmarcarTodosSegmentos()
  },
  methods: {
    selecionarSegmento ({id}) {
      this.$store.dispatch("segmentosCompra/adicionar", id)
    },
    descelecionarSegmento ({id}) {
      this.$store.dispatch("segmentosCompra/remover", id)
    },
    selecionarTodosSegmentos () {
      this.$store.dispatch(
        "segmentosCompra/adicionarTodos",
        this.Helpers.arrayColumn(this.listaSegmentos, 'id')
      )
    },
    desmarcarTodosSegmentos () {
      this.$store.dispatch("segmentosCompra/resetar")
    },
    buscarListaDeSegmentos () {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        analiseGrupoFornecedores: localStorage.analiseGrupoFornecedores,
        id_fornecedor: this.fornecedorCompra.id,
        id_comprador: this.id_comprador
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        SegmentoAPI.getSegmentosItensEmGatilhoDeCompra(headers, params)
          .then(response => {
            const {token, segmentos} = response.data
            localStorage.token = token
            this.listaSegmentos = segmentos
            this.selecionarTodosSegmentos()
          })
          .catch(() => this.Helpers.logout())
      )
    }
  }
}
</script>
